module.exports = __webpack_public_path__ + "img/general-juanfe.21751eef.webp";